import React, { Component } from 'react';
import { connect } from 'react-redux';
import { PieChart } from 'react-minimal-pie-chart';
import '../../components/balancestyle.scss';
import SvgPieOver from '../../icons/svgPieOver';
import Loader from '../../components/loader';
import AssetConfig from '../../components/assetconfig';
import moment from 'moment';

import {
  fetchLastLoginValue,
} from '../../actions';

class Overview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: '',
      selectedTotal: '',
      selectedCur: '',
    };
    this.totalBalance = this.totalBalance.bind(this);
    this.pieData = this.pieData.bind(this);
    this.lastLoginValue = this.lastLoginValue.bind(this);
    this.showLastLoginChange = this.showLastLoginChange.bind(this);
  }

  componentDidMount() {
    const { dispatch, userCurrencyHandle } = this.props;
    const data = {
      asset: userCurrencyHandle,
    };
    dispatch(fetchLastLoginValue(data));
  }

  setSelected(val) {
    const { user, eurTstValue } = this.props;
    const { selected } = this.state;

    if (selected === val.handle) {
      this.setState({
        selected: '',
        selectedTotal: '',
        selectedCur: '',
      });
      return;
    }

    let userCurrencyHandle;
    let currencyHandle;
    if (user && user.me && user.me.defaults && user.me.defaults.currencyHandle) {
      userCurrencyHandle = user.me.defaults.currencyHandle;
    }
    if (val.currencyHandle) {
      currencyHandle = val.currencyHandle;
    } else {
      currencyHandle = userCurrencyHandle;
    }

    let selectedSum = '0.00';
    if (val.total) {
      selectedSum = (val.total) / 100;
    }

    // // TODO REMOVE ONCE TST CALCULATED ON API
    // if (val.handle === 'TST') {
    //   selectedSum = (eurTstValue(val.quantity));
    // }
    // //

    this.setState({
      selected: val.handle,
      selectedTotal: selectedSum,
      selectedCur: currencyHandle,
    });
  }

  lastLoginValue(value) {
    const { dispatch, percentChange, showAsset, lastFx, balance } = this.props;

    const newVal = Number(value / 100);

    let oldValues;
    let oldVal = 0;

    if (lastFx) {
      if (lastFx.lastExchangeRate) {
        oldValues = lastFx.lastExchangeRate;
      }
      let settledBalances;
      if (balance && balance.data && balance.data.length) {
        settledBalances = balance.data.filter(function (item) {
          return item.type === 'SETTLED';
        });
      }

      const oldValLoop = settledBalances && settledBalances.map((item) => {
        let oldItem;
        let useVal;
        if (item.handle && oldValues) {
          if (showAsset(item.handle)) {
            oldItem = oldValues.find(function (old) {
              return item.handle === old.handle;
            });
            if (oldItem && oldItem.rate) {
              useVal = (Number(oldItem.rate / 100) * Number(item.quantity));
            }
            return {
              handle: item.handle,
              oldValue: useVal,
            };
          }
        }
      });
      if (oldValLoop && oldValLoop.length) {
        oldVal = oldValLoop
          .map((item) => {
            if (item && item.oldValue) {
              return item.oldValue;
            }
            return null;
          })
          .reduce((prev, curr) => prev + curr, 0);
      }

      if (oldVal && newVal) {
        return percentChange('LOGIN', newVal, oldVal);
      }
    }
  }

  totalBalance(type) {
    const { balance, user, currencySign, toLocaleFixed, showAsset, eurTstValue } = this.props;

    let enabledBalanceSettled = 0;
    let balanceSettled = 0;

    let currencyHandle;
    if (user && user.me && user.me.defaults && user.me.defaults.currencyHandle) {
      currencyHandle = user.me.defaults.currencyHandle;
    }

    if (balance && balance.data && balance.data.length) {
      balanceSettled = balance.data.filter(function (item) {
        return item.type === 'SETTLED';
      });
    }

    if (balanceSettled && balanceSettled.length) {
      enabledBalanceSettled = balanceSettled.filter(function (item) {
        return showAsset(item.handle);
      });
    }

    let totalSum = 0;
    if (enabledBalanceSettled && enabledBalanceSettled.length) {
      totalSum = enabledBalanceSettled.reduce((sum, obj) => {

        let useTotal = 0;
        if (obj.total) {
          useTotal = obj.total;
        }

        return sum + useTotal
      }, 0);
    }

    let formattedSum = (0).toFixed(2);
    if (totalSum) {
      formattedSum = toLocaleFixed((totalSum / 100), 2);
    }
    const totalFormatted = (currencySign(currencyHandle) + formattedSum);

    if (type === 'CHANGE') {
      return Number(totalSum);
    }
    return totalFormatted;
  }

  pieData() {
    const { balance, showAsset, eurTstValue } = this.props;
    const { selected } = this.state;
    let balanceSettled;

    if (balance && balance.data && balance.data.length) {
      balanceSettled = balance.data.filter(function (item) {
        return item.type === 'SETTLED';
      });
    }

    const colors = {};
    if (AssetConfig && AssetConfig.length) {
      AssetConfig.forEach((item) => {
        let useHandle;
        if (item.handle) {
          useHandle = item.handle;
        }
        let useColors;
        if (item.colors) {
          useColors = item.colors;
        }
        colors[useHandle] = useColors;
      });
    }

    let enabledBalanceSettled;
    if (balanceSettled && balanceSettled.length) {
      enabledBalanceSettled = balanceSettled.filter((item) => showAsset(item.handle));
    }

    const data = enabledBalanceSettled && enabledBalanceSettled.map((item) => {
      let useHandle;
      if (item.handle) {
        useHandle = item.handle;
      }
      let useTotal = Number(0);
      if (item.total) {
        useTotal = Number(item.total / 100);
      }

      // // TODO REMOVE ONCE TST CALCULATED ON API
      // if (item.handle === 'TST') {
      //   useTotal = (Number(eurTstValue(item.quantity)));
      // }
      // //

      let useColor;
      if (colors && colors[useHandle]) {
        let primary;
        if (colors[useHandle].primary) {
          primary = colors[useHandle].primary;
        }
        if (selected) {
          if (selected === useHandle) {
            useColor = 'rgb(' + primary + ')';
          } else {
            useColor = 'rgba(' + primary + ', 0.2)';
          }
        } else {
          useColor = 'rgb(' + primary + ')';
        }
      }
      return (
        {
          name: useHandle.toLowerCase(),
          value: useTotal,
          color: useColor,
        }
      );
    });
    return data;
  }

  showLastLoginChange() {
    const { lastFx } = this.props;
    let lastLoginDate;
    if (lastFx && lastFx.lastLogin) {
      lastLoginDate = moment.unix(lastFx.lastLogin).format('L');
    }
    if (lastLoginDate) {
      return (lastLoginDate);
    }
    return null;
  }

  render() {
    const {
      balance,
      user,
      AssetOrder,
      showAsset,
      currencySign,
      toLocaleFixed,
      percentChange,
      lastFx,
      humName,
      eurTstValue,
      eurEthLoading,
      fxSnapDay,
    } = this.props;

    const {
      selected,
      selectedTotal,
      selectedCur,
    } = this.state;

    let lastLoginDate = '';
    if (lastFx && lastFx.lastLogin) {
      lastLoginDate = moment.unix(lastFx.lastLogin).format('L');
    }

    let userCurrencyHandle;
    if (user && user.me && user.me.defaults && user.me.defaults.currencyHandle) {
      userCurrencyHandle = user.me.defaults.currencyHandle;
    }

    const totalValue = this.totalBalance();

    let balanceSettled;

    if (balance && balance.data && balance.data.length) {
      balanceSettled = balance.data.filter(function (item) {
        return item.type === 'SETTLED';
      });
    }

    let orderedSettled;
    if (balanceSettled) {
      orderedSettled = balanceSettled.slice(0).sort(function (a, b) {
        let aIndex = AssetOrder.indexOf(a.handle);
        let bIndex = AssetOrder.indexOf(b.handle);
        if (aIndex == -1) {
          aIndex = AssetOrder.length + 1;
        }
        if (bIndex == -1) {
          bIndex = AssetOrder.length + 1;
        }
        const sorted = aIndex - bIndex;
        return sorted;
      });
    }

    let ydaySettledValue;
    if (orderedSettled && orderedSettled.length) {
      ydaySettledValue = orderedSettled && orderedSettled.length && orderedSettled.map((asset) => {
        let yesterdayAsset;
        if (fxSnapDay && fxSnapDay.length) {
          yesterdayAsset = fxSnapDay.find(function(item) {
            if (item && item.handle) {
              return item.handle === asset.handle;
            }
          });
        }
        let value;
        if ((yesterdayAsset && yesterdayAsset.value) && (asset && asset.quantity)) {
          value = Number(yesterdayAsset.value) * Number(asset.quantity);
        }
        return {
          handle: asset.handle,
          value,
        };
      });
    }

    let ydayTotalVal = 0;
    if (ydaySettledValue && ydaySettledValue.length) {
      ydayTotalVal = ydaySettledValue.reduce((sum, obj) => {
        let useTotal = 0;
        if (obj.value) {
          useTotal = obj.value;
        }
        return sum + useTotal
      }, 0);
    }

    let totalYdayValChange = '';
    let totalYdayValChangePercent = '';
    let isGainTotal = true;
    if (ydaySettledValue) {
      if (this.totalBalance('CHANGE') < ydayTotalVal) {
        isGainTotal = false;
      }
      totalYdayValChange = Math.abs(Number(this.totalBalance('CHANGE') - ydayTotalVal));
      totalYdayValChangePercent = percentChange('RAW', ydayTotalVal, this.totalBalance('CHANGE'));
    }


    const balancesLoop = orderedSettled && orderedSettled.map((value, index) => {
      let useHandle = '';
      if (value.handle) {
        let useTotal;
        if (value.total) {
          useTotal = value.total;
        }
        useHandle = humName(value.handle);
        let assetYdayTotalVal = 0;
        let assetYday;
        if (ydaySettledValue && ydaySettledValue.length) {
          assetYday = ydaySettledValue.find(function (item) {
            if (item && item.handle) {
              return item.handle === value.handle;
            }
          });
        }
        if (assetYday && assetYday.value) {
          assetYdayTotalVal = assetYday.value;
        }

        let assetYdayValChange = '';
        let assetYdayValChangePercent = '';
        let isGainTotal = true;
        if (ydaySettledValue) {
          if (useTotal < assetYdayTotalVal) {
            isGainTotal = false;
          }
          assetYdayValChange = Math.abs(Number(useTotal - assetYdayTotalVal));
          assetYdayValChangePercent = percentChange('RAW', assetYdayTotalVal, this.totalBalance('CHANGE'));
        }

        if (showAsset(value.handle)) {
          return (
            <div key={index} className={selected === value.handle ? 'balances-item active-item' : 'balances-item'} onClick={() => this.setSelected(value)}>
              <div className="balances-coin-wrap">
                <div className={'balances-coin vlt-coin ' + useHandle.replace(/\s/g, "-").toLowerCase()}>
                  <img alt={useHandle} src={process.env.REACT_APP_CDN + '/assets/icons/assets/' + useHandle.replace(/\s/g, "-").toLowerCase() + '.svg'} />
                </div>
              </div>
              <div className="balances-name">
                {useHandle}
              </div>
              <div className="balances-info">
                <span>
                  {value.quantity}
                </span>
                <div>
                  {currencySign(value.currencyHandle || userCurrencyHandle)}
                  { useTotal ? (
                    toLocaleFixed((useTotal / 100), 2)
                  ) : (
                    Number('0').toFixed(2)
                  )}
                </div>
                <div className="balances-change">

                  <div
                    style={isGainTotal ? {
                      fontSize: 14,
                      color: '#30dea7'
                    } : {
                      fontSize: 14,
                      color: '#FF6060'
                    }
                  }>
                    {assetYdayValChange ? (
                      <>
                        {isGainTotal ? (
                          <span className="pt-pos">
                            {'\u25B2 '}
                          </span>
                        ) : (
                          <span className="pt-neg">
                            {'\u25BC '}
                          </span>
                        )}
                        {currencySign(userCurrencyHandle)}
                        {' '}
                        {toLocaleFixed((assetYdayValChange / 100), 2)}
                        {' (24h)'}
                      </>
                    ) : (null)}
                  </div>

                </div>
              </div>
            </div>
          );
        }
      }
    });

    const overviewReady = balancesLoop;

    if (overviewReady) {
      return (
        <div className="overview-container">
          <div className="o-c-side">
            <div className="o-c-circle">
              <SvgPieOver width="100%" height="100%" className="o-c-c-chart-over" />
              <PieChart
                data={this.pieData()}
                radius={40}
                lineWidth={12}
                className="o-c-c-chart"
              />
              <PieChart
                data={this.pieData()}
                radius={40}
                lineWidth={12}
                className="o-c-c-chart-blur"
              />
              { selected ? (
                <div className="o-c-balances o-c-b-break">
                  <div>
                    {currencySign(selectedCur)}
                    {toLocaleFixed(selectedTotal, 2)}
                  </div>
                  <div style={{ textTransform: 'uppercase' }}>{selected}</div>
                  <div>of</div>
                  <div>{this.totalBalance()}</div>
                  <div style={{ textTransform: 'uppercase' }}>Total</div>
                </div>
              ) : (
                <div className="o-c-balances">
                  <div>Total Value</div>
                  <div>{this.totalBalance()}</div>

                  <div className="assetSummaryChangeCon">
                    <div
                      style={isGainTotal ? {
                        fontSize: 14,
                        color: '#30dea7'
                      } : {
                        fontSize: 14,
                        color: '#FF6060'
                      }
                    }>
                      {totalYdayValChange ? (
                        <>
                          {isGainTotal ? (
                            <span className="pt-pos">
                              {'\u25B2 '}
                            </span>
                          ) : (
                            <span className="pt-neg">
                              {'\u25BC '}
                            </span>
                          )}
                          {currencySign(userCurrencyHandle)}
                          {' '}
                          {toLocaleFixed((totalYdayValChange / 100), 2)}
                          {' (24h)'}
                        </>
                      ) : (
                        <>
                          <span className="pt-pos">
                            {'\u25B2 '}
                          </span>
                          {currencySign(userCurrencyHandle) + Number('0').toFixed(2) + ' (24h)'}
                        </>
                      )}
                    </div>


                    <div
                      className={isGainTotal ? (
                        'assetHeaderSideChangeCon assetHeaderSideChangeConGain'
                      ) : (
                        'assetHeaderSideChangeCon assetHeaderSideChangeConLoss'
                      )}
                    >
                      {isGainTotal ? (
                        <span style={{color: 'white', marginRight: '8px'}}>
                          {'\u25B2'}
                        </span>
                      ) : (
                        <span style={{color: 'white', marginRight: '8px'}}>
                          {'\u25BC'}
                        </span>
                      )}
                      <div className="assetHeaderSideChangeText">
                        {totalYdayValChangePercent || 0}%
                      </div>
                    </div>

                  </div>

                </div>
              )}
            </div>
            <div className="o-c-info hide-md cell panel">
              <p style={{marginTop: 0}}>Overview</p>
              <div className="lr-p">
                <span className="mute">
                  Total Value
                </span>
                <span>
                  {this.totalBalance()}
                </span>
              </div>
              <div className="lr-p">
                <span className="mute">
                  Last Login
                </span>
                <span>
                  {lastLoginDate}
                </span>
              </div>
              <div className="lr-p">
                <span className="mute">
                  Change Since Last Login
                </span>
                <span>
                  {this.lastLoginValue(this.totalBalance('CHANGE'))}
                </span>
              </div>
              <a
                className="vlt-btn wide"
                href="/direct"
                style={{marginTop: 20}}
              >
                Sell
              </a>
            </div>
          </div>
          <div className="balances-container">
            <div className="show-md" style={{width: '100%', marginBottom: '20px'}}>
              <a
                className="vlt-btn wide"
                href="/direct"
              >
                Sell
              </a>
            </div>
            {balancesLoop}
          </div>
        </div>
      );
    }
    return (
      <div className="center-loader">
        <Loader logo />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  balance: state.balance.balance,
  lastFx: state.balance.lastFx,
  errors: state.user.errors,
  fxSnapDay: state.balance.fxSnapDay,
});

export default connect(mapStateToProps)(Overview);
